// ===== Chat.js =====
import React from 'react';
import StreamlinedChatApp from './StreamlinedChatApp';
import useChatPhases from '../hooks/useChatPhases';

const Chat = ({ onLogout }) => {
  const [hasInitialized, setHasInitialized] = React.useState(false);

  const {
    currentPhase,
    formHandlers,
    reportS3Url,
    message,
    setMessage,
    agentStatus,
    sessionId,
    userName,
    finalMessages,
    sonnetTypingText,
    sonnetIsTyping,
    sonnetWsConnected,
    sonnetWsConnecting,
    currentStatus,
    startReportGeneration,
    resetToForm,
    handleSendChatMessage,
    error,
    chatError,
    processingStage,
    isLoading,
    requestUrlRefresh,
    registerUrlRefreshCallback,
    // Reports
    savedReports,
    savedReportContent,
    isLoadingReports,
    handleLoadSavedReports,
    handleViewSavedReport,
    // Sessions
    savedSessions,
    isLoadingSessions,
    handleLoadSessions,
    handleLoadSessionAndSwitch,
    handleDeleteSession,
    requestNewSession,
    handleDeleteReport
  } = useChatPhases();

  // Auto-start chat
  React.useEffect(() => {
    if (currentPhase === 'form' && sonnetWsConnected && !hasInitialized) {
      setHasInitialized(true);
      if (formHandlers?.setBusinessDescription) {
        formHandlers.setBusinessDescription('General business research and analysis');
      }
      setTimeout(() => {
        if (startReportGeneration) startReportGeneration();
      }, 100);
    }
  }, [currentPhase, sonnetWsConnected, startReportGeneration, formHandlers, hasInitialized]);

  return (
    <StreamlinedChatApp
      message={message}
      setMessage={setMessage}
      messages={finalMessages || []}
      isTyping={sonnetIsTyping}
      wsConnected={sonnetWsConnected}
      wsConnecting={sonnetWsConnecting}
      onSendMessage={handleSendChatMessage}
      error={error || chatError}
      typingText={sonnetTypingText}
      onLogout={onLogout}
      reportUrl={reportS3Url}
      onRestart={resetToForm}
      currentStatus={currentStatus}
      processingStage={processingStage}
      isLoading={isLoading}
      sessionId={sessionId}
      userName={userName}
      requestUrlRefresh={requestUrlRefresh}
      registerUrlRefreshCallback={registerUrlRefreshCallback}
      agentStatus={agentStatus}
      // Reports
      savedReports={savedReports}
      savedReportContent={savedReportContent}
      isLoadingReports={isLoadingReports}
      onLoadSavedReports={handleLoadSavedReports}
      onViewSavedReport={handleViewSavedReport}
      onDeleteReport={handleDeleteReport}
      // Sessions
      savedSessions={savedSessions}
      isLoadingSessions={isLoadingSessions}
      onLoadSessions={handleLoadSessions}
      onLoadSession={handleLoadSessionAndSwitch}
      onDeleteSession={handleDeleteSession}
      onRequestNewSession={requestNewSession}
    />
  );
};

export default Chat;